import React from 'react';

const CheckboxGroup = ({ children }) => <div className="ws-ui-checkbox-group">{children}</div>;

export default CheckboxGroup;
